// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1_Mc0","cls2":"MultiPaperModal-cls2_g1U MultiPaperModal-cls1_Mc0"};